<ul>
    <li *ngFor="let item of treeItems | mappingDisplayOrder: pipeCounter; index as i">
        <!-- TREE NODE -->
        <section class="tree-node"
                 *ngIf="item.isVisible"
                 [ngClass]="{'drag-over': draggedOver === item}">
            <button mat-icon-button
                    *ngIf="!isRoot"
                    class="small-icon-button"
                    [disabled]="item.isEditMode"
                    (click)="onToggleItem(item)">
                <mat-icon>{{ item.isOpen ? 'expand_more' : 'chevron_right' }}</mat-icon>
            </button>
            <span class="label"
                  [class.no-drag]="isRoot || !canEditMapping"
                  [draggable]="!isRoot && canEditMapping"
                  [matTooltip]="item.text ? item.text.detail : item.description"
                  [matTooltipPosition]="'after'"
                  (dragstart)="onDrag($event, item)"
                  (drop)="onDrop($event, item)"
                  (dragover)="allowDrop($event)"
                  (dragenter)="onDragOver($event, item)"
                  (dragleave)="onDragOver($event)">
                {{ !isRoot ? (item.text ? item.text.fullLabel : item.label) : ('mapping.base.tree.root.shortLabel' |
                translate)
                }}
                <ng-container *ngIf="!isRoot && item.validFrom && item.validTo && displayValidity">
                    <!-- [{{ item.id }}] -->
                    ({{ item.validFrom | date: dateFormat}} -> {{ item.validTo | date: dateFormat }})
                </ng-container>
            </span>

            <ng-container *ngIf="!item.isEditMode && !isRoot && canEditMapping">
                <button mat-icon-button
                        color="accent"
                        class="small-icon-button"
                        [matTooltip]="'mapping.base.tree.edit.fullLabel' | translate"
                        (click)="onEditStarted(item)">
                    <mat-icon aria-label="Add">create</mat-icon>
                </button>
                <button mat-icon-button
                        color="accent"
                        class="small-icon-button"
                        [matTooltip]="'mapping.base.tree.delete.fullLabel' | translate"
                        (click)="onDelete(item)">
                    <mat-icon aria-label="Add">delete</mat-icon>
                </button>
                <button mat-icon-button
                        color="accent"
                        class="small-icon-button"
                        [disabled]="item.displayOrder === 0"
                        (click)="moveUp(i)">
                    <mat-icon aria-label="move up">expand_less</mat-icon>
                </button>
                <button mat-icon-button
                        color="accent"
                        class="small-icon-button"
                        [disabled]="item.displayOrder === treeItems.length - 1"
                        (click)="moveDown(i)">
                    <mat-icon aria-label="move down">expand_more</mat-icon>
                </button>
            </ng-container>
        </section>

        <section class="tree-form"
                 *ngIf="item.isEditMode">
            <app-edit-form [item]="item"
                           (valueSubmitted)="onEditFinished(item, $event)"></app-edit-form>
        </section>

        <!-- DEPENDENCIES -->
        <mat-expansion-panel class="deps mat-elevation-z0"
                             *ngIf="item.dependencies && item.dependencies.length && item.isOpen">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h3>{{ depsLabel }}s</h3>
                </mat-panel-title>
                <mat-panel-description>
                    {{ item.dependencies.length }}
                </mat-panel-description>
            </mat-expansion-panel-header>

            <app-dependencies-list [canEditMapping]="canEditMapping"
                                   [dependencies]="item.dependencies"
                                   [isDense]="true"
                                   [label]="depsLabel"
                                   (listChanged)="onDepsChanged($event, item)"></app-dependencies-list>
        </mat-expansion-panel>

        <!-- CHILDREN -->
        <app-tree-items *ngIf="item.children && item.isOpen"
                        [canEditMapping]="canEditMapping"
                        [treeItems]="item.children"
                        [depsLabel]="depsLabel"
                        [displayValidity]="displayValidity"
                        (listChanged)="onChildrenChanged($event, item)"></app-tree-items>
    </li>

    <!-- NEW NODE FORM -->
    <li class="create-line"
        *ngIf="!isRoot && canEditMapping">
        <button mat-icon-button
                disabled>
            <mat-icon>chevron_right</mat-icon>
        </button>
        <button mat-icon-button
                color="accent"
                *ngIf="!isCreationMode"
                [matTooltip]="'mapping.base.tree.add.fullLabel' | translate"
                (click)="onAddStarted()">
            <mat-icon aria-label="Add">add</mat-icon>
        </button>
        <app-edit-form *ngIf="isCreationMode"
                       (valueSubmitted)="onAddFinished($event)"></app-edit-form>
    </li>
</ul>